module.exports = __webpack_public_path__ + "img/girlmoney.ab391356.svg";